import { Button, Card, Flex, Image, Tag } from "antd";
import { observer } from "mobx-react";
import Subjects from "../../models/subjects";
import { useStore } from "../../stores/root-store";
import TaskCloneStore from "../../stores/task/task-clone";

const imageSize = 500;
const TaskImportCloneCard: React.FC<{ task: TaskCloneStore, subject: Subjects}> = ({ task, subject }) => {

    const { subjectStores, fileService } = useStore();
    const newTicket = subjectStores[subject].newTicket;
    const ticketBar = subjectStores[subject].ticketBar;
    const { id } = task.data;

    const handleTicketAction = () => {
        newTicket.toggleTaskInTicket(id, ticketBar);
    }

    return <Card title={`Задача ${task.data.id}`} className='card'
        extra={
            <Flex align="flex-end" vertical>
                <Button type="link" size="small" onClick={handleTicketAction}>{newTicket.contains(id) ? "Убрать из варианта" : "Добавить в вариант"}</Button>
            </Flex>}
    >
        <Card.Meta
            description={
                <div>
                    <Tag color="magenta">{task.data.theme?.name}</Tag>
                    <Tag color='green'>{task.data.source.name}</Tag>
                    <Tag color="cyan">Номер в КИМ {task.data.numberInKim?.name}</Tag>
                    {task.data.tags.map(tag => <Tag key={tag}>{tag}</Tag>)}
                </div>
            }
        />
        {task.data.photoIds &&
            <Flex wrap="wrap" gap="small" style={{ marginTop: "20px" }}>
                <Image.PreviewGroup >
                    <Image key={task.data.photoIds[0]} width={imageSize} src={fileService.getFileUrl(task.data.photoIds[0])} placeholder={true}/>
                </Image.PreviewGroup>
            </Flex>
        }
    </Card>;
}

export default observer(TaskImportCloneCard);